import type { UnpackedModelMetadata } from '@/services/device-service/devices'

export interface DeviceModelsState {
  modelsMetaData: UnpackedModelMetadata
}

export enum DEVICE_MODELS_MUTATIONS {
  SET_MODELS_META_DATA = 'setModelsMetaData'
}

export enum DEVICE_MODELS_ACTIONS {
  SET_MODELS_META_DATA = 'setModelsMetaData'
}

export enum DEVICE_MODELS_GETTERS {
  GET_ALLOW_PUBLIC = 'getAllowPublic',
  GET_SHOW_AQI = 'getShowAQI',
  GET_SHOW_CONDITION = 'getShowCondition',
  GET_SHOW_CONNECTIVITY = 'getShowConnectivity',
  GET_SHOW_LAST_COMMUNICATION = 'getShowLastCommunication',
  GET_SHOW_MAP_SETTINGS = 'getShowMapSettings',
  GET_SHOW_REGISTRATION = 'getShowRegistration',
  GET_SHOW_SUBSCRIPTION = 'getShowSubscription',
  GET_TELEMETRY_FIELDS_BY_MODEL = 'getTelemetryFieldsByModel',
  GET_MODELS = 'getModels',
  GET_SHOW_MAP_SETTINGS_MODELS = 'getShowMapSettingsModels',
  GET_SUBMODELS = 'getSubmodels',
  GET_MODEL_NAME = 'getModelName',
  GET_MODEL_NAMES_MAP = 'getModelNamesMap',
  GET_MODEL_PRODUCT_FAMILY = 'getModelProductFamily',
  GET_MODEL_KEY = 'getModelKey',
  GET_SUBMODEL_KEY = 'getSubmodelKey',
  GET_SERIAL_LENGTH = 'getSerialLength',
  GET_INDOOR_ONLY = 'getIndoorOnly',
  GET_SHOW_CALIBRATION = 'getShowCalibration',
  GET_SHOW_INDOOR_SENSOR = 'getShowIndoorSensor',
  GET_SHOW_INTERVAL_SETTINGS = 'getShowIntervalSettings',
  GET_SHOW_LOCATION = 'getShowLocation',
  GET_FAQ_LINK = 'getFaqLink',
  GET_CALIBRATION_LIMITS = 'getCalibrationLimits',
  GET_ALLOWED_RANGE_LIMITS = 'getAllowedRangeLimits',
  GET_SUPPORTED_MEASUREMENTS = 'getSupportedMeasurements',
  GET_ALERTABLE_MEASUREMENTS = 'getAlertableMeasurements',
  GET_ZEROABLE_MEASUREMENTS = 'getZeroableMeasurements',
  MODEL_SUPPORTS_ZEROING = 'modelSupportsZeroing',
  MODEL_SUPPORTS_AUTO_CAL = 'modelSupportsAutoCal',
  GET_PIN_PATH = 'getPinPath',
  GET_STATE_FIELDS = 'getStateFields'
}
